// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__13ENY","title__low":"style_title__low__1Fppl"};